import { AdProps, LayoutProps } from '@sport1/types/web'

function extractMatchTeams(layout: LayoutProps | undefined): [string, string] | '' {
    const tracking = layout?.meta?.tracking

    const targeting =
        layout?.meta?.ad?.targeting ||
        (layout?.components?.find(component => (component as AdProps)?.ad?.targeting) as AdProps)
            ?.ad.targeting ||
        {}

    const isFootballChannel = targeting.channel === 'fussball'

    if (!isFootballChannel) {
        return ''
    }

    const playingTeams = tracking?.find(val => val.key === 'sportsdata_match')
    const playingTeamsString = playingTeams?.value ?? ''
    const regex = /^\s*(.+?)\s*vs\.?\s*(.+?)\s*\|\s*\d{2}\.\d{2}\.\d{4}\s*$/i
    const matchResult = playingTeamsString.match(regex)

    if (!matchResult || matchResult.length < 3) {
        return ''
    }

    const [, team1, team2] = matchResult

    const slugify = (team: string): string => {
        return team
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '')
    }

    const slug1 = slugify(team1)
    const slug2 = slugify(team2)

    if (!slug1 || !slug2) {
        return ''
    }

    return [slug1, slug2]
}

export { extractMatchTeams }
